import { takeLatest, put, call, takeEvery } from "redux-saga/effects";
import { toast } from "react-toastify";

//Redux Actions
import CONSTANTS from "../CONSTANTS";
import AssetsService from "services/AssetsService";
import { actionGetAvailableAssets, actionSetAssetsList, actionSetAssetTypes, actionSetAvailableAssets, actionSetEditAsset, actionUpdateAssetInList } from "../actions/assetsActions";

function* sagaGetAssetsList({ page, limit, search }) {
  const cancelToken = AssetsService.getSource();

  try {
    const result = yield call(AssetsService.getAssetsList, page, limit, search, {cancelToken: cancelToken.token});
    if (result.status >= 400) {
      throw new Error('Get assets failed');
    }
    yield put(actionSetAssetsList(result.data));
  } catch (error) {
    toast.error(error.message || 'Get assets failed');
  }
}

function* sagaAssetSubmitForm({ data }) {
  const cancelToken = AssetsService.getSource();
  try {
    const result = yield call(AssetsService.createAsset, data, {cancelToken: cancelToken.token});
    if (result.status >= 400) {
      throw new Error('Create assets failed');
    }
    toast.success('Asset created successfully');
    yield put(actionSetEditAsset({}));
  } catch (e) {
    toast.error(e.message || 'Submit asset failed');
  }
}

function* sagaAssetSubmitEdition({ data }) {
  const cancelToken = AssetsService.getSource();
  try {
    const result = yield call(AssetsService.editAsset, data, {cancelToken: cancelToken.token});
    if (result.status >= 400) {
      throw new Error('Edit assets failed');
    }
    toast.success('Asset edited successfully');
    yield put(actionSetEditAsset({}));
  } catch (e) {
    toast.error(e.message || 'Edit asset failed');
  }
}

function* sagaGetAvailableAssets({ page, limit, search, typeFilter }) {
  const cancelToken = AssetsService.getSource();
  try {
    const result = yield call(AssetsService.getAvailableAssets, page, limit, search, typeFilter, {cancelToken: cancelToken.token});
    if (result.status >= 400) {
      throw new Error('Get assets failed');
    }
    yield put(actionSetAvailableAssets(result.data));
  } catch (e) {
    toast.error(e.message || 'Get asset failed');
  }
}

function* sagaMarkAssetAsReserved({ assetId, page, limit, search, typeFilter }) {
  const cancelToken = AssetsService.getSource();
  try {
    const result = yield call(AssetsService.markReserved, assetId, {cancelToken: cancelToken.token});
    if (result.status >= 400) {
      throw new Error('Update asset failed');
    }
    yield put(actionGetAvailableAssets(page, limit, search, typeFilter));
  } catch (e) {
    toast.error(e.message || 'Update asset failed');
  }
}

function* sagaMarkAssetAsAvailable({ assetId, page, limit, search, typeFilter }) {
  const cancelToken = AssetsService.getSource();
  try {
    const result = yield call(AssetsService.markAvailable, assetId, {cancelToken: cancelToken.token});
    if (result.status >= 400) {
      throw new Error('Update asset failed');
    }
    yield put(actionGetAvailableAssets(page, limit, search, typeFilter));
  } catch (e) {
    toast.error(e.message || 'Update asset failed');
  }
}

function* sagaDeleteAsset({ assetId }) {
  const cancelToken = AssetsService.getSource();
  try {
    const result = yield call(AssetsService.deleteAsset, assetId, {cancelToken: cancelToken.token});
    if (result.status >= 400) {
      throw new Error('Delete asset failed');
    }
    toast.success("Asset deleted");
    yield put(actionUpdateAssetInList(assetId, "deleted"));
  } catch (e) {
    toast.error(e.message || 'Delete asset failed');
  }
}

function* sagaGetAssetTypes() {
  const cancelToken = AssetsService.getSource();
  try {
    const result = yield call(AssetsService.getAssetTypes, {cancelToken: cancelToken.token});
    if (result.status >= 400) {
      throw new Error('Error getting asset types');
    }
    yield put(actionSetAssetTypes(result.data));
  } catch (e) {
    toast.error(e.message || 'Error getting asset types');
  }
}

export function* assetsSaga() {
    yield takeLatest(CONSTANTS.ASSETS_GET_LIST, sagaGetAssetsList);
    yield takeLatest(CONSTANTS.ASSETS_SUBMIT_FORM, sagaAssetSubmitForm);
    yield takeLatest(CONSTANTS.ASSETS_SUBMIT_EDIT, sagaAssetSubmitEdition);
    yield takeLatest(CONSTANTS.ASSETS_GET_AVAILABLE, sagaGetAvailableAssets);
    yield takeLatest(CONSTANTS.ASSETS_MARK_RESERVED, sagaMarkAssetAsReserved);
    yield takeLatest(CONSTANTS.ASSETS_MARK_AVAILABLE, sagaMarkAssetAsAvailable);
    yield takeLatest(CONSTANTS.ASSETS_DELETE, sagaDeleteAsset);
    yield takeLatest(CONSTANTS.ASSETS_GET_TYPES, sagaGetAssetTypes);
}
  